import SyncStatusBadge from './SyncStatusBadge';

export default SyncStatusBadge;
